import moment from 'moment-timezone'

export const getTimeFromDecimal = t => {
  const hours = parseInt(t % 24)
  return `${hours < 10 ? `0${hours}` : hours}:${t % 1 > 0 ? '30' : '00'}`
}

export const getTimeForSelection = time => {
  return time ? time.replace(/^0+/, '') : null
}

// TODO: @Serginyo90 write tests
// must save date without relation to timezone for count correct start ProTrackLevel's date
export const convertDateToUTC = days => {
  const format = 'YYYY-MM-DD[T]00:00:00.[000Z]'
  return days.map(day => {
    return {
      ...day,
      startDate: day.startDate.format(format),
      endDate: day.endDate.format(format),
    }
  })
}

export const isDateToday = date => moment().isSame(date, 'day')

// this function adds 1 if 1 is minute, hour, day, month or year. In moment returns without number if 1 minute or hour, day, month, year
export const formatRelativeDate = (date: string): string => {
  const keywords = ['h', 'min', 'd', 'month', 'year']
  const regex = /^(\d+)/
  const match = date.match(regex)

  if (!match && date !== 'yesterday' && date !== 'just now') {
    const containsKeyword = keywords.some(keyword => date.includes(keyword))
    if (containsKeyword) {
      return `1 ${date}`
    } else {
      return date
    }
  } else {
    return date
  }
}
